function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_13654_58151)"
}, React.createElement("path", {
  d: "M11.7492 1.5C12.7042 1.5 13.5942 1.967 14.1392 2.747L14.2442 2.907L22.3582 16.455C22.6048 16.8821 22.739 17.3648 22.7481 17.8578C22.7573 18.3509 22.6412 18.8382 22.4107 19.2742C22.1802 19.7101 21.8428 20.0805 21.4301 20.3505C21.0174 20.6205 20.543 20.7813 20.0512 20.818L19.8562 20.826H3.63121C3.13891 20.8205 2.65605 20.6903 2.22768 20.4476C1.79932 20.2049 1.43942 19.8577 1.18158 19.4383C0.92374 19.0189 0.77637 18.541 0.753223 18.0492C0.730076 17.5574 0.831907 17.0678 1.04921 16.626L1.14821 16.441L9.25821 2.903C9.51787 2.47481 9.8835 2.12077 10.3198 1.87502C10.7562 1.62927 11.2484 1.50011 11.7492 1.5Z",
  fill: "#D58917"
}), React.createElement("path", {
  d: "M11.6325 14.8371L11.7595 14.8301L11.8765 14.8371C12.1196 14.866 12.3436 14.983 12.5061 15.166C12.6686 15.3491 12.7584 15.5853 12.7584 15.8301C12.7584 16.0748 12.6686 16.3111 12.5061 16.4941C12.3436 16.6771 12.1196 16.7942 11.8765 16.8231L11.7495 16.8301L11.6325 16.8231C11.3895 16.7942 11.1655 16.6771 11.0029 16.4941C10.8404 16.3111 10.7506 16.0748 10.7506 15.8301C10.7506 15.5853 10.8404 15.3491 11.0029 15.166C11.1655 14.983 11.3895 14.866 11.6325 14.8371Z",
  fill: "white"
}), React.createElement("path", {
  d: "M11.0851 8.08279C11.2682 7.92003 11.5046 7.83011 11.7495 7.83008C11.9944 7.83011 12.2308 7.92003 12.4139 8.08279C12.5969 8.24555 12.7139 8.46983 12.7425 8.71308L12.7495 8.83008V12.8301L12.7425 12.9471C12.7136 13.1901 12.5966 13.4141 12.4135 13.5767C12.2305 13.7392 11.9943 13.829 11.7495 13.829C11.5047 13.829 11.2685 13.7392 11.0855 13.5767C10.9025 13.4141 10.7854 13.1901 10.7565 12.9471L10.7495 12.8301V8.83008L10.7565 8.71308C10.7852 8.46983 10.9021 8.24555 11.0851 8.08279Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_13654_58151"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgWarningIconPlaceTpslModal = function SvgWarningIconPlaceTpslModal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarningIconPlaceTpslModal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WarningIconPlaceTpslModal.e4f699e4.svg";
export { ForwardRef as ReactComponent };